module.exports = __webpack_public_path__ + "static/media/warning.27b50fac.svg";